import Nullstack from 'nullstack';
export default function IconIceCream({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-ice-cream",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 21.5v-4.5"
  }), "   ", Nullstack.element("path", {
    d: "M8 17h8v-10a4 4 0 1 0 -8 0v10z"
  }), "   ", Nullstack.element("path", {
    d: "M8 10.5l8 -3.5"
  }), "   ", Nullstack.element("path", {
    d: "M8 14.5l8 -3.5"
  }), " ");
}